import { memo, useMemo, PropsWithChildren } from 'react';

import { Column } from 'shared/Houston';

import useHoustonTheme from '@eduzz/houston-styles/useHoustonTheme';

interface IProps {}

const PageColumn: React.FC<PropsWithChildren<IProps>> = ({ children }) => {
  const theme = useHoustonTheme();

  const stylesProp = useMemo(
    () => ({
      marginBottom: theme.spacing.xxs
    }),
    [theme]
  );

  return (
    <Column xs={12} {...stylesProp}>
      {children}
    </Column>
  );
};

export default memo(PageColumn);
